export const Spacer = (props) => <div style={{ flexGrow: 1, ...props.style }} />